import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { message } from 'antd'
import dayjs from 'dayjs'
import { updateBooking } from '../../../../Bookings/utils/utils'
import { updateAllBookingsState } from '../../../../lib/booking-utils'
import { handleError } from '../../../../lib/utils'

export const useViewingRecord = (data, refreshFunction) => {
  const authState = useSelector((state) => state.auth)
  const serviceState = useSelector((state) => state.services.data)
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const [recordData, setRecordData] = useState(data ? data : null)
  const [reassigning, setReassigning] = useState(false)
  const [rescheduling, setRescheduling] = useState(false)
  const [rescheduleDate, setRescheduleDate] = useState(null)
  const [rescheduleTime, setRescheduleTime] = useState(null)
  const [updatingBooking, setUpdatingBooking] = useState(false)

  const onAfterCancel = () => {
    refreshFunction()
  }

  const onSuccess = () => {
    setLoading(false)
    refreshFunction()
  }

  const onFail = () => {
    setLoading(false)
  }

  const handleReassignment = async (value, target, medicalProfessionals) => {
    let payload = {}
    let newBooking = null
    let newMedProfName = medicalProfessionals.find((i) => i._id === value)
    payload[target] = value
    setReassigning(true)
    try {
      newBooking = await updateBooking(payload, { _id: recordData._id })
      updateAllBookingsState({
        ...newBooking,
        professionalName: `${newMedProfName.firstName} ${newMedProfName.lastName}`
      })
      setRecordData({ ...recordData, ...newBooking })
      refreshFunction()
    } catch (e) {
      message.error(handleError(e))
    }
    setReassigning(false)
  }

  const handleReschedule = async () => {
    const serviceInfo = serviceState.find((i) => i._id === data.service)
    if (!serviceInfo) {
      return message.error('Error')
    }
    let newBooking = null
    setUpdatingBooking(true)

    try {
      newBooking = await updateBooking(
        {
          bookingDate: dayjs(rescheduleDate).format('YYYY-MM-DD'),
          startTime: rescheduleTime,
          endTime: dayjs(rescheduleTime, 'HH:mm').add(serviceInfo.timeslotInterval, 'minutes').format('HH:mm')
        },
        { _id: recordData._id }
      )
      updateAllBookingsState({
        ...newBooking
      })
      setRecordData({ ...recordData, ...newBooking })
      refreshFunction()
      resetRescheduleData()
    } catch (e) {
      message.error(handleError(e))
    }
    setUpdatingBooking(false)
  }

  const resetRescheduleData = () => {
    setRescheduleTime(null)
    setRescheduleDate(null)
    setRescheduling(false)
  }

  return {
    // State
    loading,
    setLoading,
    recordData,
    setRecordData,
    reassigning,
    rescheduling,
    setRescheduling,
    rescheduleDate,
    setRescheduleDate,
    rescheduleTime,
    setRescheduleTime,
    updatingBooking,

    // Redux state
    authState,
    serviceState,
    dispatch,

    // Functions
    onAfterCancel,
    onSuccess,
    onFail,
    handleReassignment,
    handleReschedule,
    resetRescheduleData
  }
}
